import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import BaseAPI from '../../api/apiurl';

const ApexPWeekly = () => {
  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: []
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(0) + "%"; // Convert to fixed decimal places (0 in this case)
        }
      }
    },
    series: [
      {
        name: "series-1",
        data: []
      },
      {
        name: "series-2",
        data: []
      }
    ]
  });

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        // Get company_id and customer_id from local storage
        const companyId = localStorage.getItem("companyid");
        const customerId = localStorage.getItem("customerid");
  
        // Assuming you have a function to get data from the API
        const response = await fetch(`${BaseAPI}projectperccount?company_id=${companyId}&customer_id=${customerId}`);
        const data = await response.json();
  
        // Update chartData based on API response
        const categories = data.data.map(item => item.status);
        const seriesData = data.data.map(item => item.count);
        const percentageData = data.data.map(item => Math.round(item.percentage));
  
        setChartData({
          options: {
            chart: {
              id: "basic-bar"
            },
            xaxis: {
              categories: categories
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val !== 0 ? val + "%" : '';
              }
            }
          },
          series: [
            {
              name: "Project Count",
              data: seriesData
            },
            {
              name: "Project Percentage",
              data: percentageData
            }
          ]
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData(); // Call the fetchData function
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount
  
  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            width="500"
          />
        </div>
      </div>
    </div>
  );
};

export default ApexPWeekly;

